import { scrollToElement } from '@lib/scroller';

const scrollToAnchor = (event: MouseEvent): void => {
  event.preventDefault();

  const target = event.target as HTMLAnchorElement;
  const href = target.getAttribute('href');
  if (!href) return;

  const id = href.substring(1);
  const targetElement = document.getElementById(id);

  if (targetElement) {
    scrollToElement(targetElement);
  }
};

const smoothScrollingElements = (): void => {
  const anchorLinks =
    document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

  anchorLinks.forEach((anchor) => {
    anchor.addEventListener('click', scrollToAnchor);
  });
};

export default smoothScrollingElements;
